import { render, staticRenderFns } from "./InclusiveNode.vue?vue&type=template&id=b622395c&scoped=true"
import script from "./InclusiveNode.vue?vue&type=script&lang=js"
export * from "./InclusiveNode.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNode.vue?vue&type=style&index=0&id=b622395c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b622395c",
  null
  
)

export default component.exports